import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/Wishlist.css";

const WishlistPage = () => {
  const [wishlist, setWishlist] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const data = JSON.parse(localStorage.getItem("wishlist")) || [];
    setWishlist(data);
  }, []);

  const handleAccess = (book) => {
    if (!book.price || book.price === "0") {
      window.open(book.pdf_link, "_blank"); // free access
    } else if (book.purchased) { // if you track purchased books
      window.open(book.pdf_link, "_blank");
    } else {
      alert("Access Denied! Please buy this book to access it.");
    }
  };

  return (
    <div className="wishlist-page">
      <div className="container">


        {wishlist.length === 0 ? (
          <div className="empty-state">
            <div className="empty-content">
              <div className="empty-icon">
                <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                  <path d="M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H20v20H6.5a2.5 2.5 0 0 1 0-5H20"/>
                  <path d="M9 10h6"/>
                  <path d="M9 14h6"/>
                </svg>
              </div>
              <h2>Your wishlist is empty</h2>
              <p>Start building your reading list by adding books you're interested in.</p>
              <button 
                className="cta-button"
                onClick={() => navigate('/allpages')}
              >
                Browse Library
              </button>
            </div>
          </div>
        ) : (
          <div className="content-section">
            <div className="section-header">
              <h2 className="section-title">
                {wishlist.length} {wishlist.length === 1 ? 'Book' : 'Books'} Saved
              </h2>
            </div>
            
            <div className="wishlist-grid">
              {wishlist.map((book, index) => (
                <div key={index} className="book-card2">
                  <div className="book-header">
                    <div className="book-icon">
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <path d="M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H20v20H6.5a2.5 2.5 0 0 1 0-5H20"/>
                      </svg>
                    </div>
                    <div className="price-badge">
                      {(!book.price || book.price === "0") ? (
                        <span className="badge free">Free</span>
                      ) : (
                        <span className="badge premium">₹{book.price}</span>
                      )}
                    </div>
                  </div>
                  
                  <div className="book-content">
                    <h3 className="book-title">{book.pdf_name}</h3>
                  </div>
                  
                  <div className="book-actions">
                    <button 
                      className={`action-button ${(!book.price || book.price === "0") || book.purchased ? 'primary' : 'secondary'}`}
                      onClick={() => handleAccess(book)}
                    >
                      {(!book.price || book.price === "0") || book.purchased ? "Read Book" : "Get Access"}
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default WishlistPage;